import { env } from '../../config/env';
import { ApiResponse } from '../../types/api';
import { BaseSearchParams } from '../../types/search';
import { get, post } from '../../utils/api';

// API Layer - Only handles raw API calls and responses
export class ContentApiService {
  private static instance: ContentApiService;
  private baseUrl: string;

  private constructor() {
    this.baseUrl = `${env.apiBaseUrl}`;
  }

  static getInstance(): ContentApiService {
    if (!ContentApiService.instance) {
      ContentApiService.instance = new ContentApiService();
    }
    return ContentApiService.instance;
  }

  private createQueryString(params: BaseSearchParams): string {
    const searchParams = new URLSearchParams();
    
    // Required params
    searchParams.append('limit', params.limit.toString());
    searchParams.append('page', params.page.toString());
    
    // Optional common params
    if (params.term) searchParams.append('term', params.term);
    if (params.sortBy) searchParams.append('sortBy', params.sortBy);
    if (params.sortType) searchParams.append('sortType', params.sortType);
    
    return searchParams.toString();
  }

  private getErrorMessageForStatus(status: number): string {
    switch (status) {
      case 404:
        return 'errors.notFound';
      case 403:
        return 'errors.forbidden';
      case 401:
        return 'errors.unauthorized';
      case 400:
        return 'errors.badRequest';
      default:
        return status >= 500 ? 'errors.serverError' : 'errors.somethingWentWrong';
    }
  }

  async get<T>(endpoint: string, params?: Record<string, string | number | boolean | string[] | undefined>): Promise<ApiResponse<T>> {
    try {
      // Use the centralized fetch wrapper
      return await get<ApiResponse<T>>(endpoint, params, {
        validateApiResponse: false, // We want the raw ApiResponse
        baseUrl: this.baseUrl
      });
    } catch (error) {
      // Re-throw the error - it's already been logged by the fetch wrapper
      throw error;
    }
  }

  async post<T>(endpoint: string, data: any): Promise<ApiResponse<T>> {
    try {
      // Use the centralized fetch wrapper
      return await post<ApiResponse<T>>(endpoint, data, {
        validateApiResponse: false, // We want the raw ApiResponse
        baseUrl: this.baseUrl
      });
    } catch (error) {
      // Re-throw the error - it's already been logged by the fetch wrapper
      throw error;
    }
  }
}